<script lang="ts" setup>
import { TAG_ICON_SIZE, type IconNameType, type TagSizeType } from '@c4-links/vue3-links-components';
import type { PropType } from 'vue';
import { computed, ref } from 'vue';
import VueFeather from 'vue-feather';
import { DECORATIVE_TAG_CLASSES } from './constants/decorativeTagClasses.constant';
import type { DecorativeTagColorType } from './types/decorativeTagColor.type';

const props = defineProps({
  icon: { type: String as PropType<IconNameType>, required: false, default: undefined },
  size: { type: String as PropType<TagSizeType>, default: 'M' },
  color: {
    type: String as PropType<DecorativeTagColorType>,
    default: 'misty'
  }
});
const colorClx = ref(DECORATIVE_TAG_CLASSES[props.color]);

const wrapperClx = computed(() => ({
  'text-xs h-6 px-2 py-1': props.size === 'S',
  'text-sm h-8 px-2 py-1.5': props.size === 'M',
  'text-sm h-10 px-2 py-2.5': props.size === 'L'
}));

const iconClx = computed(() => ({
  'h-4': props.size === 'S' || props.size === 'M',
  'h-6': props.size === 'L'
}));
</script>

<template>
  <div
    :class="[wrapperClx, colorClx]"
    class="border border-border-main-primary rounded inline-block text-decorative-content"
  >
    <div class="flex items-center h-full">
      <div v-if="icon" :class="iconClx" class="pr-1 h-4">
        <VueFeather :type="icon" :size="TAG_ICON_SIZE[size]" aria-hidden="true" />
      </div>
      <span class="whitespace-nowrap font-bold"><slot /></span>
    </div>
  </div>
</template>
